import React, { Component } from 'react';
import { postReq } from '../api/restHelper';
import { Formik } from 'formik';

class Loginform extends Component {

    render() {
        return (
            <div className="login-page-forms">
                <h4>ورود به پنل کاربری</h4>
                <Formik
                    initialValues={{
                        phone: ''
                    }}
                    validate={ values => {
                        let errors = {};
                        if (!values.phone) {
                            errors.phone = 'وارد کردن شماره موبایل الزامی است.';
                        } else if (
                        !/^((\+98)|0)[0-9]{10}$/i.test(values.phone.toEnglishDigits())
                        ) {
                        errors.phone = 'شماره موبایل وارد شده معتبر نیست.';
                        }
                        return errors;
                    }}
                    onSubmit = {( values, actions) => {
                        postReq({
                            phone_number: values.phone.toEnglishDigits()
                            },'user/activate/code', 
                                (res) => {
                                    this.props.changeStatus(2);
                                    this.props.setPhone(values.phone.toEnglishDigits());
                                },
                                (err) => {
                                if( err.response.status === 404 ){
                                    this.props.setPhone(values.phone.toEnglishDigits());
                                    this.props.changeStatus(1);
                                }
                                actions.setSubmitting(false);
                        }, false);
                    }}
                    render = { ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                        <form name="loginForm" onSubmit={handleSubmit}>
                            <div className="content">
                                <div className="form-group">
                                    <input type="text" title="شماره موبایل" placeholder="شماره موبایل" name="phone" value={values.phone} onChange={handleChange} className="text-center" dir="ltr"/>
                                    <div className="form-error"> {(touched.phone && errors.phone) ? (errors.phone):(null)} </div>
                                </div>                                    
                            </div>
                            <div className="footer text-center">
                                <button type="submit" disabled={isSubmitting}>ورود</button>
                            </div>
                        </form>
                    )}/>
            </div>
        );
    }
}

export default Loginform;

